import { SectionStatus } from '../api'

export interface SectionState {
  id: string;
  details: SectionStateDetails;
}

export function defaultSectionState(id: string): SectionState {
  return { id, details: defaultSectionStateDetails() };
}

export interface SectionStateDetails {
  status: SectionStatus;
  progress: {
    completion: number;
    scroll: number;
    page: number;
  };
  durationSeconds: number;
}

export function defaultSectionStateDetails(): SectionStateDetails {
  return {
    status: SectionStatus.notAttempted,
    progress: {
      completion: 0,
      scroll: 0,
      page: 0
    },
    durationSeconds: 0
  };
}
